import { render } from "./ZhaiHead.vue?vue&type=template&id=4177cc4a&scoped=true"
import script from "./ZhaiHead.vue?vue&type=script&lang=js"
export * from "./ZhaiHead.vue?vue&type=script&lang=js"

import "./ZhaiHead.vue?vue&type=style&index=0&id=4177cc4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4177cc4a"]])

export default __exports__